import lottie, { AnimationItem, AnimationConfigWithPath, AnimationConfigWithData } from 'lottie-web';

/**
 * 使用 lottie 创建一个动画，并且将 lottie json 的 assets 中的路径进行替换，替换成项目中的相对路径
 *
 * @param {(AnimationConfigWithPath | AnimationConfigWithData)} params lottie 创建需要的参数列表
 * @param {string[]} [images] 用于替换的图片列表
 * @returns {AnimationItem}
 */
function loadAnimation(params: AnimationConfigWithPath | AnimationConfigWithData, images?: string[]): AnimationItem | null {
  const newParams = params;
  const { animationData } = newParams as AnimationConfigWithData;
  if (animationData) {
    const { assets } = animationData;

    if (images && assets) {
      (assets as any[]).forEach((item, index) => {
        item.u = '';
        item.p = images[index]
      });
    }
  
  }
  return lottie.loadAnimation(newParams);
}

export {
  loadAnimation
}
